export default "__VITE_ASSET__ed5c2a81__"